import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import { CSSProperties } from 'styled-components';

interface InfoBoxProps {
  type: 'success' | 'error';
  message: string;
  onDismiss?(): void;
  style?: CSSProperties;
}

export const InfoBox: React.FC<InfoBoxProps> = (props) => {
  const gridStyle: CSSProperties = {
    backgroundColor: props.type === 'error' ? 'rgba(255, 226, 226, 1)' : 'rgba(76, 175, 80, 1)',
    borderRadius: '4px',
    width: 'fit-content',
    ...props.style,
  };

  const messageStyle: CSSProperties = {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    letterSpacing: '0.15px',
    padding: '14px 0px',
    textAlign: 'left',
  };

  const iconSelector = (): JSX.Element => {
    switch (props.type) {
      case 'success':
        return <CheckCircleIcon htmlColor="#347F42" />;
      case 'error':
        return <InfoOutlinedIcon htmlColor="#BC0000" />;
    }
  };

  return (
    <Grid container alignItems="center" style={gridStyle}>
      <Grid item xs={1}>
        {iconSelector()}
      </Grid>
      <Grid item xs={props.onDismiss ? 10 : 11} style={messageStyle}>
        {props.message}
      </Grid>
      {props.onDismiss && (
        <Grid item xs={1}>
          <Button
            onClick={props.onDismiss}
            style={{
              minWidth: 'unset',
            }}
          >
            <CloseIcon />
          </Button>
        </Grid>
      )}
    </Grid>
  );
};
